import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';
const PAGE_INFO = '?currentPage=1&pageUnit=30';
export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getCommCodeDetails({ codeType, commCd }) {
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/eo4mApcn/v1/commCdType/${codeType}/commCd/${commCd}/commCdDesc${PAGE_INFO}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce() {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/eo4mCustCodeLists`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		const queryStr = objectToQueryString({
			strDt: searchParams.strDt,
			endDt: searchParams.endDt,
			partNo: searchParams.partNo,
			altrNo: searchParams.altrNo,
			cofCd: searchParams.cofCd ? searchParams.cofCd : searchParams.cofNm,
			pgsStEmCd: searchParams.pgsStEmCd,
			isirCsetScnCd: searchParams.isirCsetScnCd,
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/eo4mApcn/v1/eo4mApcns${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getOne({ partNo, altrNo }) {
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/eo4mApcn/v1/partNo/${partNo}/altrNo/${altrNo}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async saveData(param) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/eo4mApcn/v1/status/1`, param, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateData1(param) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/eo4mApcn/v1/status/2/partNo/${param.partNo}/altrNo/${param.altrNo}`, param, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateData(param) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/eo4mApcn/v1/status/2/partNo/${param.partNo}/altrNo/${param.altrNo}`, param);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async deleteData(params) {
		try {
			const { partNo, altrNo } = params;
			const response = await client.post(`${BASE_URL}/pqy/pcku/eo4mApcn/v1/status/3/partNo/${partNo}/altrNo/${altrNo}`, params);
			return response.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
